import script from "./TradePassportSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradePassportSummary.vue?vue&type=script&setup=true&lang=ts"

import "./TradePassportSummary.vue?vue&type=style&index=0&id=b646cc20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b646cc20"]])

export default __exports__